var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound63AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M51 39c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11 11 4.925 11 11Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M39.5 16.5A2.5 2.5 0 0 1 37 19H25.5a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 25.5 4h14v12.5ZM17.5 39.5A2.5 2.5 0 0 1 20 42v11.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 5 53.5v-14h12.5ZM57 16.5a2.5 2.5 0 0 1-2.5 2.5H43a2.5 2.5 0 0 1-2.5-2.5V4h14A2.5 2.5 0 0 1 57 6.5v10ZM17.5 22a2.5 2.5 0 0 1 2.5 2.5V36a2.5 2.5 0 0 1-2.5 2.5H5v-14A2.5 2.5 0 0 1 7.5 22h10Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M57 14V6.5A2.5 2.5 0 0 0 54.5 4h-29A2.5 2.5 0 0 0 23 6.5V14M15 22H7.5A2.5 2.5 0 0 0 5 24.5v29A2.5 2.5 0 0 0 7.5 56H15"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M62.5 38.5A2.5 2.5 0 0 1 60 36V24.5a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v14H62.5ZM62.5 56a2.5 2.5 0 0 1-2.5-2.5V42a2.5 2.5 0 0 1 2.5-2.5H75v14a2.5 2.5 0 0 1-2.5 2.5h-10Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M65 56h7.5a2.5 2.5 0 0 0 2.5-2.5v-29a2.5 2.5 0 0 0-2.5-2.5H65"
})));
SvgRound63AError.viewBox = '0 0 80 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound63AError);
export default ForwardRef;